import { useTranslation } from '../../hooks/useNavConfig';
import { memoWithDisplayName } from '../utils/memoWithDisplayName';
import { SVGIconBase } from './SvgIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
export const FavoriteIcon = memoWithDisplayName('FavoriteIcon', props => {
  const {
    t
  } = useTranslation();
  const ariaLabel = t('nav.bookmarks2.primaryNav');
  return /*#__PURE__*/_jsx(SVGIconBase, Object.assign({
    "aria-label": ariaLabel,
    "data-test-id": "nav-favorite-icon"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M25.5,30.5c-.26,0-.52-.1-.71-.3l-8.66-8.78-8.93,8.79c-.29.28-.72.37-1.09.21-.37-.16-.61-.52-.61-.92V2.5c0-.55.45-1,1-1h19c.55,0,1,.45,1,1v26.99c0,.41-.25.77-.62.93-.12.05-.25.07-.38.07ZM7.5,3.5v23.6l7.94-7.82c.39-.39,1.03-.38,1.41.01l7.65,7.76V3.5H7.5Z"
    })
  }));
});
export const FavoriteIconSolid = memoWithDisplayName('FavoriteIconSolid', props => {
  const {
    t
  } = useTranslation();
  const ariaLabel = t('nav.bookmarks2.primaryNav');
  return /*#__PURE__*/_jsx(SVGIconBase, Object.assign({
    "aria-label": ariaLabel,
    "data-test-id": "nav-favorite-icon-solid"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.5,2.51v26.99c0,.41-.24.77-.62.93-.12.05-.25.07-.38.07-.26,0-.52-.1-.71-.3l-8.66-8.78-8.93,8.79c-.28.29-.71.37-1.08.21-.38-.15-.62-.52-.62-.92V2.51c0-.56.45-1,1-1h19c.55,0,1,.44,1,1Z"
    })
  }));
});